import { NgModule } from '@angular/core';

import { TranslationPipe } from '../pipes';
import { FormsModule } from '@angular/forms';
import { CommonModule } from '@angular/common';

/**
 * Shared module
 * contains common components/pipes/directives and also export commonly used Angular modules (CommonModule, FormsModule)
 */
@NgModule({
    imports: [
        CommonModule,
        FormsModule
    ],
    declarations: [
        TranslationPipe
    ],
    exports: [
        CommonModule,
        FormsModule,
        TranslationPipe
    ]
})
export class SharedModule {
}



// WEBPACK FOOTER //
// ./src/app/shared/shared.module.ts